import Big from 'big.js';

/**
 * decimal文字列またはnumber型からBig型を作成（V1/V2 API統合用）
 *
 * V2 APIではdecimal文字列、V1 APIではnumber型で数値が提供される。
 * この関数はどちらの形式でも適切にBig型に変換し、精度を保持する。
 *
 * @param decimalString - V2 APIからのdecimal文字列（優先）
 * @param numberValue - V1 APIからのnumber値（フォールバック）
 * @returns Big型オブジェクト、または変換できない場合はnull
 *
 * @example
 * // V2 API: decimal文字列を優先
 * const big = createBigFromDecimalOrNumber('15.75', 15.749999999999998);
 * // => Big('15.75') (精度が保たれる)
 *
 * // V1 API: number値を使用
 * const big = createBigFromDecimalOrNumber(undefined, 15.75);
 * // => Big('15.75')
 */
export function createBigFromDecimalOrNumber(decimalString?: string, numberValue?: number): Big | null {
  // decimal文字列を優先して処理
  if (decimalString !== undefined && decimalString !== null && decimalString !== '') {
    try {
      return new Big(decimalString);
    } catch (error) {
      console.error('Failed to parse decimal string:', decimalString, error);
    }
  }

  // decimal文字列が無効またはundefinedの場合、numberValueを使用
  if (numberValue !== undefined) {
    return new Big(numberValue);
  }

  return null;
}

/**
 * Big | number を Big型に統一する
 *
 * @param value - Big型またはnumber型の値
 * @returns Big型オブジェクト
 *
 * @example
 * ensureBig(123.45) // => Big('123.45')
 * ensureBig(new Big('123.45')) // => Big('123.45') (そのまま返す)
 */
export function ensureBig(value: Big | number): Big {
  return typeof value === 'number' ? new Big(value) : value;
}
